import React from 'react';
import { Risk } from "./risk";
import { Documents } from './documents';
import LinkingTemplate from "../../../../components/Forms/linkingTemplate";

export function LocationTemplate({
  template,
  conf,
  user,
  location,
  namespace,
}) {
  switch (template) {
    case 'risk':
      return <Risk location={location} conf={conf} user={user} />;
    case 'documents':
      return <Documents location={location} conf={conf} user={user} />;
    case 'linkingSubjects':
      return <LinkingTemplate conf={conf} namespace={namespace} />
    default:
      return null;
  }
}